export default "__VITE_ASSET__DwKGLget__"